const FALLBACKS = {
  VITE_BACKOFFICE_URL: "http://localhost:5185",
  VITE_API_BASE_URL: "http://localhost:3000/api",
  VITE_AUTH_CLIENT_ID: "backoffice",
  VITE_BASE_PATH: "/",
} as const;

const getEnvValue = <T extends keyof typeof FALLBACKS>(key: T) => {
  const value = import.meta.env[key];

  if (typeof value === "string" && value.length > 0) {
    return value;
  }

  return FALLBACKS[key];
};

export const getBackofficeUrl = () => getEnvValue("VITE_BACKOFFICE_URL");
export const getApiBaseUrl = () => getEnvValue("VITE_API_BASE_URL");
export const getAuthClientId = () => getEnvValue("VITE_AUTH_CLIENT_ID");
export const getBasePath = () => getEnvValue("VITE_BASE_PATH");

export const getEnvironment = (): "dev" | "staging" | "production" => {
  const env = import.meta.env.VITE_ENVIRONMENT;
  if (env === "staging" || env === "production") return env;
  return "dev";
};
